var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submitForm($event)
        }
      }
    },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "primary", "background-color": "grey lighten-4" },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c("v-tab", { attrs: { href: "#sales" } }, [
            _vm._v(_vm._s(_vm.$t("invoicing.options.tabs.sales")))
          ]),
          _c("v-tab", { attrs: { href: "#purchase" } }, [
            _vm._v(_vm._s(_vm.$t("invoicing.options.tabs.purchase")))
          ])
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "sales" } },
            [
              _c(
                "v-expansion-panels",
                {
                  staticClass: "pa-2",
                  attrs: { multiple: "" },
                  model: {
                    value: _vm.openSalesPanels,
                    callback: function($$v) {
                      _vm.openSalesPanels = $$v
                    },
                    expression: "openSalesPanels"
                  }
                },
                [
                  _vm._l(_vm.salesGroups, function(group) {
                    return [
                      group.options.length > 0
                        ? _c(
                            "v-expansion-panel",
                            { key: group.key },
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticClass: "font-weight-medium",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "actions",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-chip",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  "x-small": "",
                                                  color: "grey lighten-2"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(group.options.length)
                                                )
                                              ]
                                            ),
                                            _c("v-icon", [
                                              _vm._v("mdi-chevron-down")
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [_vm._v(" " + _vm._s(group.label) + " ")]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                _vm._l(group.options, function(opt) {
                                  return _c(
                                    "v-row",
                                    {
                                      key: opt._idx,
                                      staticClass: "mx-0 align-center",
                                      attrs: { dense: "" }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-1",
                                          attrs: { cols: "auto" }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-0 pt-0",
                                            attrs: {
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value:
                                                _vm.checkedValues[opt._idx],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.checkedValues,
                                                  opt._idx,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "checkedValues[opt._idx]"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { staticClass: "py-1" },
                                        [
                                          _vm.getOptionTypeLabel(opt.type) ===
                                          "String"
                                            ? [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: opt.name,
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: opt.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        opt,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "opt.value"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Integer"
                                            ? [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: opt.name,
                                                    type: "number",
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: opt.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        opt,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "opt.value"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Decimal"
                                            ? [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: opt.name,
                                                    type: "number",
                                                    step: "0.01",
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.decimalValues[
                                                        opt._idx
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.decimalValues,
                                                        opt._idx,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "decimalValues[opt._idx]"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Date"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "caption grey--text text--darken-1 mt-1"
                                                  },
                                                  [_vm._v(_vm._s(opt.name))]
                                                ),
                                                _c("v-date-picker", {
                                                  attrs: {
                                                    disabled: !opt.canBeModified
                                                  },
                                                  model: {
                                                    value: opt.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        opt,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "opt.value"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Boolean"
                                            ? [
                                                _c("v-switch", {
                                                  attrs: {
                                                    label: opt.name,
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.booleanValues[
                                                        opt._idx
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.booleanValues,
                                                        opt._idx,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "booleanValues[opt._idx]"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Guid"
                                            ? [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: opt.name,
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: opt.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        opt,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "opt.value"
                                                  }
                                                })
                                              ]
                                            : _vm
                                                .getOptionTypeLabel(opt.type)
                                                .startsWith("Dictionary")
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "caption grey--text text--darken-1 mt-1"
                                                  },
                                                  [_vm._v(_vm._s(opt.name))]
                                                ),
                                                _vm._l(opt.items, function(
                                                  item,
                                                  index
                                                ) {
                                                  return _c(
                                                    "v-row",
                                                    {
                                                      key: index,
                                                      attrs: { dense: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              disabled: !opt.canBeModified,
                                                              dense: "",
                                                              "hide-details": ""
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "prepend",
                                                                  fn: function() {
                                                                    return [
                                                                      _c(
                                                                        "v-chip",
                                                                        {
                                                                          staticClass:
                                                                            "mt-n1",
                                                                          attrs: {
                                                                            small:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formatPercentage(
                                                                                item.key
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  },
                                                                  proxy: true
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                            model: {
                                                              value: item.value,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "value",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.value"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                })
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "v-tab-item",
            { attrs: { value: "purchase" } },
            [
              _c(
                "v-expansion-panels",
                {
                  staticClass: "pa-2",
                  attrs: { multiple: "" },
                  model: {
                    value: _vm.openPurchasePanels,
                    callback: function($$v) {
                      _vm.openPurchasePanels = $$v
                    },
                    expression: "openPurchasePanels"
                  }
                },
                [
                  _vm._l(_vm.purchaseGroups, function(group) {
                    return [
                      group.options.length > 0
                        ? _c(
                            "v-expansion-panel",
                            { key: group.key },
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticClass: "font-weight-medium",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "actions",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-chip",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  "x-small": "",
                                                  color: "grey lighten-2"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(group.options.length)
                                                )
                                              ]
                                            ),
                                            _c("v-icon", [
                                              _vm._v("mdi-chevron-down")
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [_vm._v(" " + _vm._s(group.label) + " ")]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                _vm._l(group.options, function(opt) {
                                  return _c(
                                    "v-row",
                                    {
                                      key: opt._idx,
                                      staticClass: "mx-0 align-center",
                                      attrs: { dense: "" }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-1",
                                          attrs: { cols: "auto" }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-0 pt-0",
                                            attrs: {
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value:
                                                _vm.checkedValues[opt._idx],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.checkedValues,
                                                  opt._idx,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "checkedValues[opt._idx]"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { staticClass: "py-1" },
                                        [
                                          _vm.getOptionTypeLabel(opt.type) ===
                                          "String"
                                            ? [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: opt.name,
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: opt.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        opt,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "opt.value"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Integer"
                                            ? [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: opt.name,
                                                    type: "number",
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: opt.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        opt,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "opt.value"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Decimal"
                                            ? [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: opt.name,
                                                    type: "number",
                                                    step: "0.01",
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.decimalValues[
                                                        opt._idx
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.decimalValues,
                                                        opt._idx,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "decimalValues[opt._idx]"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Date"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "caption grey--text text--darken-1 mt-1"
                                                  },
                                                  [_vm._v(_vm._s(opt.name))]
                                                ),
                                                _c("v-date-picker", {
                                                  attrs: {
                                                    disabled: !opt.canBeModified
                                                  },
                                                  model: {
                                                    value: opt.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        opt,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "opt.value"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Boolean"
                                            ? [
                                                _c("v-switch", {
                                                  attrs: {
                                                    label: opt.name,
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.booleanValues[
                                                        opt._idx
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.booleanValues,
                                                        opt._idx,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "booleanValues[opt._idx]"
                                                  }
                                                })
                                              ]
                                            : _vm.getOptionTypeLabel(
                                                opt.type
                                              ) === "Guid"
                                            ? [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: opt.name,
                                                    disabled: !opt.canBeModified,
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value: opt.value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        opt,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "opt.value"
                                                  }
                                                })
                                              ]
                                            : _vm
                                                .getOptionTypeLabel(opt.type)
                                                .startsWith("Dictionary")
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "caption grey--text text--darken-1 mt-1"
                                                  },
                                                  [_vm._v(_vm._s(opt.name))]
                                                ),
                                                _vm._l(opt.items, function(
                                                  item,
                                                  index
                                                ) {
                                                  return _c(
                                                    "v-row",
                                                    {
                                                      key: index,
                                                      attrs: { dense: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              disabled: !opt.canBeModified,
                                                              dense: "",
                                                              "hide-details": ""
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "prepend",
                                                                  fn: function() {
                                                                    return [
                                                                      _c(
                                                                        "v-chip",
                                                                        {
                                                                          staticClass:
                                                                            "mt-n1",
                                                                          attrs: {
                                                                            small:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.formatPercentage(
                                                                                item.key
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  },
                                                                  proxy: true
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                            model: {
                                                              value: item.value,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  item,
                                                                  "value",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "item.value"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                })
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }